import { getAdminUrl } from "@pathwright/utils/src/url/admin"
import { useEffect, useMemo, useState } from "react"

// Iframing the /admin-tools/check/ endpoint to check for pw admin permissions.
// These permissions are stored in local storage. The /admin-tools/check/ page
// posts a message to our parent window with the value of the stored
// "enable_admin_tools" key. If "true", we enable the pw admin tools.
function PWAdminEnabled({
  onPWAdminEnabled
}: {
  onPWAdminEnabled: (enabled: boolean) => void
}) {
  const [render, setRender] = useState(false)
  const iframeUrl = useMemo(() => getAdminUrl("admin-tools/check/"), [])

  useEffect(() => {
    window.addEventListener("message", (event) => {
      if (iframeUrl.origin === event.origin) {
        console.log("PWAdminEnabled message", event.data)
        onPWAdminEnabled(event.data === "true")
      }
    })

    setRender(true)
  }, [])

  return render ? (
    <iframe id="pw-admin-iframe" src={iframeUrl.toString()} />
  ) : null
}

export default PWAdminEnabled
